import useCustomMemo from "../../Hooks/useCustomMemo";
import { WorkPointModel } from "../../Utils/Models";

/**
 * Interface for workpoint filter configuration
 */
export interface WorkPointFilterConfig {
  workPointId: string | null;
  clientWorkPointId: string | null;
}

/**
 * Utility function to determine workpoint filter configuration based on user's workpoint
 * @param workPoints - Array of workpoints from memo storage
 * @param userWorkPointId - User's workpoint ID from localStorage
 * @returns WorkPointFilterConfig object with appropriate filter settings
 */
export const getWorkPointFilterConfig = (
  workPoints: WorkPointModel[],
  userWorkPointId: string | null
): WorkPointFilterConfig => {
  // If no user workpoint ID is found, return default configuration
  if (!userWorkPointId) {
    return {
      workPointId: null,
      clientWorkPointId: null,
    };
  }

  // Find the user's workpoint
  const userWorkPoint = workPoints.find(
    (wp: WorkPointModel) => wp._id === userWorkPointId
  );

  // If workpoint not found, return default configuration
  if (!userWorkPoint) {
    return {
      workPointId: null,
      clientWorkPointId: null,
    };
  }

 userWorkPoint.isMain = false;

  // Check if the workpoint is main/principal
  if (userWorkPoint.isMain) {
    // If it's main workpoint: filter exams by workpoint, no client filter
    return {
      workPointId: userWorkPointId,
      clientWorkPointId: null,
    };
  } else {
    // If it's not main workpoint: no exam filter, filter clients by workpoint
    return {
      workPointId: null,
      clientWorkPointId: userWorkPointId,
    };
  }
};

/**
 * Custom hook that returns workpoint filter configuration
 * This can be used in React components that need the filter configuration
 */
export const useWorkPointFilterConfig = (): WorkPointFilterConfig => {
  const memo = useCustomMemo();
  const workPoints: WorkPointModel[] = memo?.storage?.workPoints || [];
  const userWorkPointId = localStorage.getItem("userWorkPointId");

  return getWorkPointFilterConfig(workPoints, userWorkPointId);
};
